import { LegalShell, LegalSection, LegalList } from "@/components/site/LegalShell";

export default function AccessibilityStatement() {
  return (
    <LegalShell
      title="Accessibility Statement"
      updated="June 2026"
      seoTitle="Accessibility Statement | AYOBELL"
      seoDesc="AYOBELL's commitment to making its marketing website accessible to as many people as possible."
    >
      <LegalSection>
        <p>AYOBELL aims to make this website accessible to as many people as possible and is continuing to review the site against recognised accessibility guidance.</p>
      </LegalSection>

      <LegalSection heading="What we do">
        <LegalList items={[
          "Use semantic HTML structure with clear headings and landmarks.",
          "Provide meaningful alternative text for images.",
          "Maintain visible keyboard focus states and support keyboard navigation.",
          "Aim for sufficient colour contrast across text and interactive elements.",
          "Design responsive layouts that work across desktop, tablet and mobile.",
        ]} />
      </LegalSection>

      <LegalSection heading="Ongoing improvement">
        <p>Accessibility is an ongoing effort. We continue to review and improve the experience across the website and welcome feedback that helps us do better.</p>
      </LegalSection>

      <LegalSection heading="Feedback">
        <p>If you experience any difficulty accessing content on this website, please contact us at <a className="text-teal-700 font-semibold" href="mailto:info@ayobell.com">info@ayobell.com</a> and we will do our best to help.</p>
      </LegalSection>
    </LegalShell>
  );
}
